const STAGES = [
  {
    icon: "ri-lightbulb-flash-line",
    step: "第一幕 · 起因",
    title: "一根引线被点燃",
    text: "通常由一段爆料、一份截图或一句原声开启。此时信息量小、关注面窄，当事人大多尚未回应，争议的‘版本’还没成形。",
  },
  {
    icon: "ri-meteor-line",
    step: "第二幕 · 发酵",
    title: "消息在传播中变形",
    text: "话题冲上热门，各路解读与延伸涌来。情绪先行、细节模糊，转发常常放大最抓眼球的一句，而忽略上下文与前提。",
  },
  {
    icon: "ri-message-2-line",
    step: "第三幕 · 回应",
    title: "当事人与证据登场",
    text: "相关方出面澄清或补充，新证据陆续放出，部分早期说法被推翻。这是信息版本最剧烈震荡的阶段，也是梳理的关键窗口。",
  },
  {
    icon: "ri-settings-4-line",
    step: "第四幕 · 沉淀",
    title: "热度退去，脉络定型",
    text: "讨论放缓后，争议留下的是可供回溯的时间线与结论。清醒的读者会在此刻回看全过程，修正此前被情绪带偏的判断。",
  },
];

export default function ShimoSection() {
  return (
    <section id="shimo" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl">
            <p className="flex items-center gap-2 text-xs tracking-widest text-primary-600 uppercase">
              <i className="ri-route-line w-4 h-4 flex items-center justify-center" />
              02 · 来龙去脉
            </p>
            <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
              拆解一场争议的四个阶段
            </h2>
            <p className="mt-4 text-foreground-700 text-sm md:text-base leading-loose">
              再扑朔迷离的事件，套上「起因—发酵—回应—沉淀」的框架，脉络也会清晰很多。
              把每一则消息归入对应阶段，你自然能看出哪个节点才是整条线的分水岭。
            </p>
          </div>
          <div className="w-full lg:w-auto">
            <a
              href="#timeline"
              className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap"
            >
              想按节点逐条看？
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
              前往时间线方法论
            </a>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {STAGES.map((s, i) => (
            <article
              key={s.step}
              className="relative bg-background-50 border border-background-200 rounded-lg p-6 flex gap-4"
            >
              <span className="hidden sm:flex w-12 h-12 flex-shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                <i className={`${s.icon} text-xl w-6 h-6 flex items-center justify-center`} />
              </span>
              <div>
                <p className="text-xs text-secondary-600 font-label tracking-wide">{s.step}</p>
                <h3 className="mt-1 font-heading font-semibold text-lg text-foreground-950">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-700 leading-relaxed">{s.text}</p>
              </div>
              <span className="absolute top-4 right-4 font-label text-4xl text-background-200 select-none">
                {String(i + 1).padStart(2, "0")}
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}